import * as types from "../../actions/types";

const initialState = {
  err: '',
  code: '',
  success: false
}

export default function updateOfficeReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_OFFICE:
      return {
        ...state,
        success: action.success,
      }
    case types.UPDATE_OFFICE_ERR:
      return {
        ...state,
        err: action.err,
        code: action.errs
      }
    default:
      return state
  }
}